import axios from "axios";
import { url, newApiBaseUrl } from "../../axiosInstance";
import { LOCATION_ID } from "./CollectSite";

export const GetProductsToOrder = (orderId, branch) => {
  return axios.get(
    `${newApiBaseUrl}/orders/${orderId}/items?branch=${LOCATION_ID}`,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${localStorage.jwtToken}`,
        "X-Tenant": "hamazon",
      },
    },
  );
};
